import Button from 'components/button'
import { Chart, List as ListIcon } from 'components/icons'
import React from 'react'
import { tv } from 'tailwind-variants'

interface ViewSwitchProps {
  value: 'chart' | 'table'
  onChange: (v: 'chart' | 'table') => void
}

const viewSwitchStyles = tv({
  slots: {
    container: 'h-10 flex items-center border border-divider rounded-lg bg-surface overflow-hidden',
    button: 'flex items-center justify-center w-11 h-[38px] transition-colors text-muted hover:bg-surface-sunken'
  },
  variants: {
    active: {
      true: {
        button: 'bg-really-light-blue text-blue hover:bg-really-light-blue'
      }
    }
  }
})

const ViewSwitch: React.FC<ViewSwitchProps> = ({ value, onChange }) => {
  const { container, button } = viewSwitchStyles()

  return (
    <div className={container()}>
      <Button
        internalType="transparent"
        onClick={() => onChange('chart')}
        aria-label="Chart view"
        className={button({ active: value === 'chart' })}
      >
        <Chart width={16} height={16} />
      </Button>
      <Button
        internalType="transparent"
        onClick={() => onChange('table')}
        aria-label="List view"
        className={button({ active: value === 'table' })}
      >
        <ListIcon width={16} height={16} />
      </Button>
    </div>
  )
}

export default ViewSwitch
